import React from 'react'
import './spinner.css'

const Spinner = () => {
  return <div className="loader"></div>
}

export default Spinner